import { TokenInfo } from '@/scopes/checkout/groups/domain/types/api'
import { QueueStore } from '@/scopes/checkout/groups/infrastructure/store/queueStore'
import { Logger } from '@/scopes/common/domain/types'
import { StoreApi } from 'zustand'

export interface QueueClient {
  createToken: () => Promise<TokenInfo>
}

export interface QueueActionsDependencies {
  store: StoreApi<QueueStore>
  client: QueueClient
  logger: Logger
  now?: () => Date
}

export function queueActions({ store, client, logger, now = () => new Date() }: QueueActionsDependencies) {
  async function pageLoaded() {
    const state = store.getState()

    const existingTurnTime = document.cookie
      .split('; ')
      .find(row => row.startsWith('QueueTurnTime='))
      ?.split('=')[1]

    if (existingTurnTime) {
      const diffSeconds = Math.max(
        0,
        Math.floor((new Date(existingTurnTime).getTime() - now().getTime()) / 1000),
      )
      state.setIn('waitingTime', diffSeconds)
      state.setIn('isFetched', true)
      return
    }

    try {
      const tokenInfo = await client.createToken()
      state.setIn('waitingTime', tokenInfo.WaitingTimeInSeconds)
    }
    catch (error) {
      state.setIn('fetchingError', true)
      logger.logError(error as Error, { action: 'pageLoaded' })
    }
    state.setIn('isFetched', true)
  }

  return {
    pageLoaded,
  }
}
